import { apiClient } from '@/api/client'
import type { WabaManagementResponse, WabaPhoneNumber, WebhookHealth, Company } from '@/types'
import { dedupeRequest } from '@/lib/dedupe-request'

export const wabaApi = {
  getWabaList: () =>
    dedupeRequest('waba-management', () =>
      apiClient.get<WabaManagementResponse>('/api/waba-management/').then((r) => r.data),
    ),

  getDefaultWaba: () =>
    apiClient.get<WabaPhoneNumber>('/api/waba-management/default/').then((r) => r.data),

  setDefaultWaba: (wabaId: string) =>
    apiClient.post(`/api/waba-management/${wabaId}/set_default/`).then((r) => r.data),

  onboarding: (data: { code: string; waba_id?: string; phone_number_id?: string }) =>
    apiClient.post('/api/waba/onboarding', data).then((r) => r.data),

  getWebhookHealth: (wabaId: string) =>
    apiClient.get<WebhookHealth>(`/api/webhook-health/${wabaId}/`).then((r) => r.data),

  // M1: post-signup verification checklist — frontend polls this to show
  // the user where they are in the onboarding gates.
  getOnboardingChecklist: (wabaId: string) =>
    apiClient
      .get<{
        company_id: number
        waba_id: number
        overall_status: 'not_started' | 'in_progress' | 'complete'
        completed_gates: number
        total_gates: number
        gates: Array<{
          id: string
          label: string
          status: 'done' | 'pending' | 'action_required'
          detail: string
        }>
      }>(`/api/${wabaId}/onboarding-checklist/`)
      .then((r) => r.data),

  // Company
  getCompany: (companyId: string) =>
    apiClient.get(`/api/company/${companyId}/`).then((r) => (r.data as { data: Company }).data ?? r.data),

  updateCompany: (companyId: string, data: Partial<Company>) =>
    apiClient.patch(`/api/company/${companyId}/`, data).then((r) => (r.data as { data: Company }).data ?? r.data),
}
